export const disableBodyScroll = () => {
  if (!import.meta.client) {
    return;
  }

  const html = document.documentElement;

  // check if there is actually scrollable content
  // if not, no need to disable scroll
  if (html.scrollHeight > html.clientHeight) {
    const scrollTop = window.pageYOffset || html.scrollTop;
    html.style.top = `-${scrollTop}px`;
    html.classList.add("no-scroll");
  }
};

export const enableBodyScroll = () => {
  if (!import.meta.client) {
    return;
  }

  const html = document.documentElement;

  if (html.classList.contains("no-scroll")) {
    // get the original scroll position
    const scrollTop = Math.abs(parseInt(html.style.top || "0"));
    html.classList.remove("no-scroll");
    html.style.removeProperty("top");
    window.scrollTo(0, scrollTop);
  }
};

export const enableFocusTrap = () => {
  window?.document.getElementById("__nuxt")!.setAttribute("inert", "true");
};

export const disableFocusTrap = () => {
  window?.document.getElementById("__nuxt")!.removeAttribute("inert");
};

export enum TailwindBreakpoint {
  ExtraSmall = "xs",
  Small = "sm",
  Medium = "md",
  Large = "lg",
  ExtraLarge = "xl",
  ExtraLarge2 = "2xl",
  ExtraLarge3 = "3xl",
  ExtraLarge4 = "4xl",
  ExtraLarge5 = "5xl",
  ExtraLarge6 = "6xl",
  ExtraLarge7 = "7xl",
}

export enum DeviceType {
  mobile = "mobile",
  tablet = "tablet",
  desktop = "desktop",
}

/**
 * Should correspond to the tailwind screens defined in `tailwind.config.js`
 */
export const BREAKPOINTS = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
  "3xl": 1600,
  "4xl": 1920,
  "5xl": 2400,
  "6xl": 3072,
  "7xl": 3200,
} satisfies Record<TailwindBreakpoint, number>;
